import React from 'react';
import { Modal } from 'antd';
import modalClose from '@/assets/images/electron/aboutclose.png';
import warnIcon from '@/assets/images/icons/modalWarn.png';
import Footer from '../components/footer';
import './templateModal.less';

interface prpsJson {
  connectModelShow: boolean;
  setConnectModelShow: (val: boolean) => void;
}

function TemplateModal(prop: prpsJson) {
  const { connectModelShow, setConnectModelShow } = prop;

  function onCancelModal() {
    setConnectModelShow(false);
  }

  const onOk = () => {
    setConnectModelShow(false);
  };

  return (
    <Modal
      wrapClassName="templateModal-box"
      visible={connectModelShow}
      width={500}
      zIndex={999999999}
      maskClosable={true}
      centered
      footer={null}
      onCancel={() => onCancelModal()}
      closeIcon={<img src={modalClose} className="cache_box_close" alt="" />}
    >
      <div className="cache_box">
        <div className="cache_box_title">
          <img src={warnIcon} alt="" />
          提醒
        </div>
        <div className="cache_box_text">
          <Footer agreementType={3}></Footer>
        </div>
        <div className="cache_box_foot">
          <div className="cache_box_btn" onClick={onOk}>
            确认
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TemplateModal;
